export default __webpack_public_path__ + "static/media/MenuActive.4b9761fd.svg";